export var ACTION;
(function (ACTION) {
    ACTION["PLEDGE_VERIFY"] = "PLEDGE_VERIFY";
    ACTION["RESEND_OTP_NUMBER"] = "RESEND_OTP_NUMBER";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["NAV_NEXT"] = "NAV_NEXT";
    ACTION["NAV_TO_NEXT_OTP"] = "NAV_NEXT_OTP";
    ACTION["GO_BACK_BUTTON"] = "GO_BACK_BUTTON";
})(ACTION || (ACTION = {}));
